import React from 'react';
import chromeDev from '../../assets/tools/chromeDev.jpg';
import dbEver from '../../assets/tools/DBeaver.png';
import figma from '../../assets/tools/figma.png';
import git from '../../assets/tools/git.png';
import insomenia from '../../assets/tools/insomnia.png';
import linux from '../../assets/tools/linux.png';
import mongoCompass from '../../assets/tools/mongodb-compass.png';
import pm2 from '../../assets/tools/pm2.png';
import reduxDev from '../../assets/tools/redux_dev.png';
import docker from '../../assets/tools/Tech-Docker-Symbol.png';
import vsCode from '../../assets/tools/Visual_Studio.png';
const toolIcons = [
    { src: chromeDev, alt: "Chrome DevTools" },
    { src: vsCode, alt: "VS Code" },
    { src: git, alt: "Git" },
    { src: dbEver, alt: "DbEver" },
    { src: insomenia, alt: "Insomnia" },
    { src: reduxDev, alt: "Redux DevTools" },
    { src: docker, alt: "Docker" },
    { src: linux, alt: "Linux" },
    { src: pm2, alt: "PM2" },
    { src: mongoCompass, alt: "MongoDB Compass" },
    { src: figma, alt: "Figma" },
];
const UseTools = () => {
    return (
        <>
            <h2><span className='text-blue-500'>T</span>ools</h2>
            <hr />
            <br />
            <div className="flex flex-wrap justify-center  items-center space-x-4 space-y-4 md:space-y-0">

                {toolIcons.map((icon, index) => (
                    <div key={index} className="relative group inline-block">
                        <img
                            src={icon.src}
                            alt={icon.alt}
                            className="h-14   transition-transform duration-300 ease-in-out transform hover:scale-110 hover:shadow-lg"
                        />
                        <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full bg-gray-700 text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            {icon.alt}
                        </span>
                    </div>
                ))}
            </div>



        </>
    );
};

export default UseTools;